export enum SprayRecordRecordStatus {
  Planned,
  Completed,
}
